var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"b1dec949-230e-4b41-a591-898319d59023","data-name":"Group 3842"},[React.createElement("line",{"id":"a2548f7f-7427-4fde-9c9d-236b2bcdb9db","data-name":"Line 8","y1":"1","x2":"19.28","y2":"1","style":{"strokeWidth":"2px"},"key":0}),React.createElement("line",{"id":"af487298-ae1a-4f93-9eb0-7e82e052e3ec","data-name":"Line 11","y1":"11.52","x2":"19.28","y2":"11.52","style":{"strokeWidth":"2px"},"key":1})]));
}

Hamburger.defaultProps = {"className":"stroke-current","id":"a6c3f561-34d3-485d-b7ff-b7a9b27cee14","data-name":"Layer 1","viewBox":"0 0 19.28 12.52","width":"100%","height":"100%"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
